import { NavigationGuardNext, Route } from 'vue-router';
import store from '@/store';

export const FillAssignment = (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  store.dispatch('assignment/getWorkToFill', Number(to.params.trabalhoId));
  next();
};
